import React from 'react'

function InfoSvg() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3528_39656)">
        <path d="M13.75 3V7C13.75 7.26522 13.85 7.51957 14.028 7.70711C14.2061 7.89464 14.4475 8 14.6993 8H18.4966" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.5968 21H7.1037C6.60016 21 6.11723 20.7893 5.76117 20.4142C5.40511 20.0391 5.20508 19.5304 5.20508 19V5C5.20508 4.46957 5.40511 3.96086 5.76117 3.58579C6.11723 3.21071 6.60016 3 7.1037 3H13.7489L18.4955 8V19C18.4955 19.5304 18.2954 20.0391 17.9394 20.4142C17.5833 20.7893 17.1004 21 16.5968 21Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.9023 14H11.8517V18H12.801" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8516 11H11.8611" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3528_39656">
          <rect width="22.7835" height="24" fill="white" transform="translate(0.458984)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default InfoSvg